// Vendor
import {printAST} from 'apollo-client';
import {ApolloLink, Observable} from 'apollo-link';
import {FetchOptions} from 'apollo-link-http';

// Types
interface Options extends FetchOptions {
  uri: string;
}

interface NamedFile {
  name: string;
  file: File;
}

// Utils
const isObject = (value: any): value is object => {
  return value !== null && typeof value === 'object';
};

const isFileList = (value: any): value is FileList => {
  return typeof FileList !== 'undefined' && value instanceof FileList;
};

const isFile = (value: any): value is File => {
  return typeof File !== 'undefined' && value instanceof File;
};

const extractFiles = (variables: any) => {
  const files: NamedFile[] = [];

  const walkTree = (tree: any, path: string | string[] = []) => {
    const mapped = Array.isArray(tree) ? tree : {...tree};

    Object.keys(mapped).forEach(key => {
      const value = mapped[key];
      const name = (Array.isArray(path) ? [...path, key] : [path, key]).join(
        '.'
      );

      if (isFile(value) || isFileList(value)) {
        const file = isFileList(value)
          ? Array.prototype.slice.call(value)
          : value;

        files.push({file, name});
        mapped[key] = name;
      } else if (isObject(value)) {
        mapped[key] = walkTree(value, name);
      }
    });

    return mapped;
  };

  return {
    files,
    variables: walkTree(variables)
  };
};

export const createAbsintheUploadMiddleware = ({uri}: Options) => {
  return new ApolloLink((operation, forward) => {
    if (isObject(operation.variables)) {
      const {variables, files} = extractFiles(operation.variables);

      if (files.length > 0) {
        const formData = new FormData();
        formData.append('query', printAST(operation.query));
        formData.append('variables', JSON.stringify(variables));
        files.forEach(({name, file}) => formData.append(name, file));

        return new Observable(observer => {
          const {headers} = operation.getContext();
          const options: RequestInit = {
            body: formData,
            headers,
            method: 'POST'
          };

          fetch(uri, options)
            .then(response => response.json())
            .then(data => {
              observer.next(data);
              observer.complete();
            })
            .catch(error => {
              observer.error(error);
            });
        });
      }
    }

    if (forward) return forward(operation);
    return null;
  });
};



// WEBPACK FOOTER //
// ./src/services/apollo/middlewares/absinthe-upload.ts